(function () {
  function shopifyConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return {};
    return cp.currentVisitorConsent() || {};
  }

  function oneTrustGroups() {
    // e.g. ",C0001,C0003," -> "C0001,C0003"
    var g = window.OnetrustActiveGroups || '';
    return g.split(',').filter(Boolean).join(',');
  }

  function syncConsent() {
    var s = shopifyConsent();
    var ot = oneTrustGroups();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Consent analytics': s.analytics || 'no answer',
          'Consent marketing': s.marketing || 'no answer',
          'Consent preferences': s.preferences || 'no answer',
          'Consent sale of data': s.sale_of_data || 'no answer',
          'Consent OneTrust groups': ot || 'no answer',
          'Consent source': ot ? 'OneTrust + Shopify' : 'Shopify only',
          'Consent recorded at': new Date().toISOString()
        }
      })
    });
    // console.log('user consent synced: s.analytics: '+ s.analytics +' s.marketing: '+ s.marketing +' s.pref: '+ s.preferences +' OT: '+ ot);
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('OneTrustGroupsUpdated', syncConsent);

  window.Shopify?.loadFeatures?.(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (err) { if (!err) setTimeout(syncConsent, 0); }
  );
})();
